import React from 'react';
import EvaluatorLeadAdminItem from '../../../Domain/EvaluatorLeadAdminItem';
import EvaluatorLeadService from '../../../Services/EvaluatorLeadService';
import EvaluatorLeadSearchParams from './EvaluatorLeadSearchParams';
import EditEvaluatorLeadWindowDescription from './EditEvaluatorLeadWindowDescription';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CommentsOverWindow from '../../../Elements/CommentsOverWindow';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';

const exportMessage =
  'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

export default class EvaluatorLeadAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownPanel: ShownPanelsEnum.None,
      searchItem: new EvaluatorLeadSearchParams(),
      selectedItem: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.closeWithRefresh = this.closeWithRefresh.bind(this);
    this.closeWithoutRefresh = this.closeWithoutRefresh.bind(this);

    EvaluatorLeadAdminItem.anonymizeFunction = this.anonymizeFunction.bind(this);
    EvaluatorLeadAdminItem.commentsFunction = this.showCommentsFunction.bind(this);
    EvaluatorLeadAdminItem.editFunction = this.showEditFunction.bind(this);
  }

  showCommentsFunction(item) {
    this.setState({ selectedItem: item, shownPanel: ShownPanelsEnum.Details });
  }

  showEditFunction(item) {
    this.setState({ selectedItem: item, shownPanel: ShownPanelsEnum.EditItem });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  handleExportExcelButtonClick() {
    EvaluatorLeadService.ExportListToExcel(this.state.searchItem).catch((error) =>
      ErrorMessage.SetErrorMessage('ELA55', error)
    );
    ErrorMessage.SetSuccessWithWait(exportMessage);
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  closeWithoutRefresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  closeWithRefresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  anonymizeFunction(evaluatorLeadId) {
    ErrorMessage.SetApprove(`Are you sure you want to anonymize Evaluator Lead #${evaluatorLeadId}?`, () => {
      EvaluatorLeadService.AnonymizeById(evaluatorLeadId)
        .then(() => {
          ErrorMessage.SetNotification('Evaluator Lead has been anonymized.');
          this.refresh();
        })
        .catch((error) => {
          ErrorMessage.SetErrorMessage('ELA35', error);
        });
    });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={new EvaluatorLeadAdminItem()}
          clickOnCancel={this.closeWithoutRefresh}
          clickOnSave={this.closeWithRefresh}
          windowDescription={EditEvaluatorLeadWindowDescription}
          errorCode='ELA63'
        />
      );
    }
    if (this.state.shownPanel === ShownPanelsEnum.EditItem && this.state.selectedItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedItem}
          clickOnCancel={this.closeWithoutRefresh}
          clickOnSave={this.closeWithRefresh}
          windowDescription={EditEvaluatorLeadWindowDescription}
          errorCode='ELA80'
        />
      );
    }
    if (this.state.shownPanel === ShownPanelsEnum.Details && this.state.selectedItem) {
      return (
        // 10034 = EntityTypeEnum.EvaluatorLead; leads are Guid-keyed, so comments use guidEntityId.
        <CommentsOverWindow
          entityTypeId={10034}
          guidEntityId={this.state.selectedItem.EvaluatorLeadId}
          label={`Comments for lead: ${this.state.selectedItem.Name}`}
          clickOnCancel={this.closeWithoutRefresh}
        />
      );
    }
    return null;
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              iconName: 'fa-solid fa-plus-circle',
              label: 'Add lead',
              tooltip: 'Add lead',
              roleKey: 'report_evaluatorleadreport_run',
              onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={EvaluatorLeadAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorLeadService.GetListBySearching}
          convertDBItemsFunction={EvaluatorLeadService.ConvertDBItems}
          orderBy='EvaluatorLeadId'
          orderDirection={OrderDirectionsEnum.Desc}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          searchParamsType={EvaluatorLeadSearchParams}
          showSearchStrip={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search by name, email or phone...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='report_evaluatorleadreport_run'
          excelExportTooltipMessage='Export to Excel based on search parameters'
          errorCode='ELA57'
        />
      </div>
    );
  }
}
